import React from 'react';
import './Pagination.css';

/**
 * Shared pager for every paginated view (PRD-1119).
 *
 * - Hidden entirely when there is one page or fewer.
 * - Derives nothing from the current page's array length — always pass a real
 *   totalPages (or totalCount + pageSize and let this compute it), so the pager
 *   doesn't disappear on a short last page.
 * - Right-aligned; anchors to the bottom of the content area via margin-top:auto
 *   when its parent is a full-height flex column (a no-op otherwise).
 */
function Pagination({ currentPage, totalPages, totalCount, pageSize, onPageChange, align = 'end' }) {
  const pages =
    typeof totalPages === 'number'
      ? totalPages
      : pageSize
        ? Math.ceil((totalCount || 0) / pageSize)
        : 0;

  if (!pages || pages <= 1) return null;

  const goPrev = () => currentPage > 1 && onPageChange(currentPage - 1);
  const goNext = () => currentPage < pages && onPageChange(currentPage + 1);

  return (
    <nav className={`resui-pagination resui-pagination--${align}`} aria-label="Pagination">
      <button
        type="button"
        className="resui-btn resui-btn--tertiary"
        onClick={goPrev}
        disabled={currentPage <= 1}
      >
        <span className="resui-btn-label">Previous</span>
      </button>
      <span className="resui-pagination-status">
        Page {currentPage} of {pages}
      </span>
      <button
        type="button"
        className="resui-btn resui-btn--tertiary"
        onClick={goNext}
        disabled={currentPage >= pages}
      >
        <span className="resui-btn-label">Next</span>
      </button>
    </nav>
  );
}

export default Pagination;
